import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../../../services/auth/auth.service';
import { combineLatest, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { EoBreadcrumbService } from 'ngx-eo-web-components';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  @Output() itemClick = new EventEmitter();
  @Output() showPatientCreateDialog = new EventEmitter();

  previoulsySelectedModule = null;
  currentRoute = '';

  token$ = this.authService.token$;
  roles: string[] | undefined = [];
  isSupplierWithNoApprovedRequests: boolean = false;

  items: MenuItem[] = [];
  subscriptions: Subscription[] = [];
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly breadcrumbService: EoBreadcrumbService

  ) { }

  ngOnInit(): void {
    this.subscriptions = [
      this.router.events.subscribe((event: any) => {
        event instanceof NavigationEnd ? (this.currentRoute = event.url) : null;
        if (!this.currentRoute && event.routerEvent instanceof NavigationEnd) {
          this.currentRoute = event.routerEvent.url;
        }
        this.items = this.generateMenuItems();
      }),
    ];

    combineLatest([
      this.token$,
    ]).subscribe(([token]) => {
      this.roles = token?.role;
      this.items = this.generateMenuItems();
    });
  }

  private filterEmptyMenuItems(items: MenuItem[]): MenuItem[] {
    return items
      .map(item => {
        if (item.items) {
          item.items = this.filterEmptyMenuItems(item.items);
        }
        return item;
      })
      .filter(item => (item.items ? item.items.length > 0 : true) && item.visible !== false);
  }

  handleModuleClick(data: any) {
    if (this.previoulsySelectedModule != undefined) {
      (this.previoulsySelectedModule as any).style = {};
      this.previoulsySelectedModule = data;
    }
  }

  isVisible(roles: string[], isHiddenForEnvironments?: string[]): boolean {
    const hasRequiredRoles =
      (roles?.length ?? 0) === 0 || this.authService.hasRoles(roles);

    return (
      hasRequiredRoles &&
      this.visibilityByEnvironment(isHiddenForEnvironments)
    );
  }

  visibilityByEnvironment(isHiddenForEnvironments: string[] | undefined): boolean {
    if (!isHiddenForEnvironments || isHiddenForEnvironments.length === 0) {
      return true; // No environment restriction, always visible
    }
    //non allowed visibility
    if (isHiddenForEnvironments.includes(environment.environmentName)) {
      return false;
    }
    return true;
  }

  menuItem(options: {
    label: string;
    icon: string;
    routerLink?: string;
    url?: string;
    command?: any;
    roles: string[];
    environmentNames?: string[];
  }): MenuItem {
    return {
      label: options.label,
      icon: `pi pi-pw ${options.icon}`,
      // routerLink: options.routerLink,
      url: options.url,
      command: () => {
        if (options.routerLink) this.router.navigate([options.routerLink]);

        if (options.command) options.command();

        if (options.routerLink && this.router.url !== options.routerLink)
          this.breadcrumbService.clear();

        this.itemClick.emit();
      },
      visible:
        this.isVisible(options.roles, options.environmentNames),
      routerLinkActiveOptions: { exact: true },
      styleClass: `${this.currentRoute === options.routerLink ? 'selected' : ''}`,
    };
  }

  generateMenuItems(): MenuItem[] {
    const allSideMenuItems = [
      {
        label: 'Λειτουργίες',
        expanded: true,
        items: [
          this.menuItem({
            label: 'Αρχική',
            icon: 'pi pi-home',
            routerLink: '/home',
            roles: [],
          }),
          this.menuItem({
            label: 'Διαχείριση Αιτήσεων Πρόσβασης API',
            icon: 'pi pi-inbox',
            routerLink: '/api-requests/search',
            roles: ['Admin', 'ApiRequester'],
          }),
          this.menuItem({
            label: 'Τεκμηρίωση Μεθόδων API',
            icon: 'pi pi-list-check',
            routerLink: '/api-endpoints-documentation/search',
            roles: ['ApiRequester', 'Admin'],
          }),
        ],
      },
      {
        label: 'Ρυθμίσεις',
        expanded: true,
        items: [
          this.menuItem({
            label: 'Διαχείριση Χρηστών',
            icon: 'pi pi-user',
            routerLink: '/user/search',
            roles: ['Admin'],
          })
        ],
      },
      {
        label: 'Λογαριασμός',
        expanded: true,
        items: [
          this.menuItem({
            label: 'Επικοινωνία',
            icon: 'pi pi-envelope',
            routerLink: '/contact',
            command: () => this.itemClick.emit(),
            roles: [],
          }),
          this.menuItem({
            label: 'Οδηγίες Χρήσης - ΡΟΛΟΣ ΧΡΗΣΤΗ ΔΙΑΧΕΙΡΙΣΤΗΣ ΚΕΝΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ',
            icon: 'pi-question-circle',
            url: `${environment.ROOT_FOLDER}/assets/files/manuals/ΡΟΛΟΣ ΧΡΗΣΤΗ ΔΙΑΧΕΙΡΙΣΤΗΣ ΚΕΝΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ.pdf`,
            roles: ['Admin'],
          }),
          this.menuItem({
            label: 'Οδηγίες Χρήσης - ΡΟΛΟΣ ΧΡΗΣΤΗΣ ΦΟΡΕΙΣ - ΧΡΗΣΤΕΣ API',
            icon: 'pi-question-circle',
            url: `${environment.ROOT_FOLDER}/assets/files/manuals/ΡΟΛΟΣ ΧΡΗΣΤΗ ΦΟΡΕΙΣ - ΧΡΗΣΤΕΣ API.pdf`,
            roles: ['ApiRequester'],
          })
        ],
      },
    ];
    return this.filterEmptyMenuItems(allSideMenuItems);
  }
}
